import { render, staticRenderFns } from "./MemberViewMemberPermissionsCard.vue?vue&type=template&id=7d8e47b1"
import script from "./MemberViewMemberPermissionsCard.vue?vue&type=script&lang=js"
export * from "./MemberViewMemberPermissionsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports